import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#about',
    label: 'About'
  }, {
    href: '#immersive-experience',
    label: 'Experience'
  }, {
    href: '#culinary',
    label: 'Culinary'
  }, {
    href: '#creators',
    label: 'Creators'
  }, {
    href: '#tickets',
    label: 'Tickets'
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6
  }} data-id="element-1143">
      <div className="container mx-auto px-4" data-id="element-1144">
        <div className="flex items-center justify-between h-20" data-id="element-1145">
          {/* Logo */}
          <a href="#hero" className="text-white font-serif text-xl tracking-wider" data-id="element-1146">
            SIKH KINGDOMS
          </a>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12" data-id="element-1147">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase font-light" data-id="element-1148">
                {link.label}
              </a>)}
          </div>
          {/* CTA Button */}
          <a href="#tickets" className="hidden md:block border border-white/30 hover:border-amber-400 px-6 py-2 text-white hover:text-amber-400 transition-colors text-sm tracking-wider uppercase" data-id="element-1149">
            Reserve
          </a>
          {/* Mobile menu button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white" data-id="element-1150">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-1151" /> : <Menu className="w-6 h-6" data-id="element-1152" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <AnimatePresence data-id="element-1153">
        {isMobileMenuOpen && <motion.div className="md:hidden bg-black border-t border-white/10" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} data-id="element-1154">
            <div className="container mx-auto px-4 py-8 space-y-6" data-id="element-1155">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase" data-id="element-1156">
                  {link.label}
                </a>)}
              <a href="#tickets" onClick={() => setIsMobileMenuOpen(false)} className="block border border-white/30 hover:border-amber-400 px-6 py-2 text-center text-white hover:text-amber-400 transition-colors text-sm tracking-wider uppercase" data-id="element-1157">
                Reserve
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
};